import { queryOptions } from '@tanstack/react-query';
import {
  AudienceService,
  type PersonaWorkspacesDto,
  type UpdatePersonaWorkspacesDto,
} from '@inference.engine/api-client/web';

import { inferenceHttp } from '@/lib/api/http-client';

import { PERSONA_QUERY_KEYS } from './query-keys';

/**
 * Which workspaces a persona is shared with, as the caller is allowed to see them: a persona can
 * be shared more widely than this returns, with the rest reported only as a count.
 */
export const getPersonaWorkspaces = async (personaId: string): Promise<PersonaWorkspacesDto> => {
  const response = await AudienceService.getAudiencePersonaWorkspaces({
    client: inferenceHttp,
    throwOnError: true,
    path: { id: personaId },
  });

  return response.data;
};

export const personaWorkspacesQuery = (personaId: string | null | undefined) =>
  queryOptions({
    queryKey: PERSONA_QUERY_KEYS.workspaces(personaId!),
    queryFn: () => getPersonaWorkspaces(personaId!),
    enabled: !!personaId,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });

/** Applies a change of scope. See `UpdatePersonaWorkspacesDto` for why the body is a delta. */
export const updatePersonaWorkspaces = async (
  personaId: string,
  delta: UpdatePersonaWorkspacesDto,
): Promise<PersonaWorkspacesDto> => {
  const response = await AudienceService.updateAudiencePersonaWorkspaces({
    client: inferenceHttp,
    throwOnError: true,
    path: { id: personaId },
    body: delta,
  });

  return response.data;
};
